module.exports = __webpack_public_path__ + "img/24.a30e73d4.png";